import datos from "src/services/datos";
import esArray from "src/general_components/functionEsArray";

export const getOwnerLocalizaciones = async (idCuenta) => {
  const owner_localizaciones = new datos("owner_localizaciones");
  owner_localizaciones.addCondition("owner_localizaciones", "id", 0, ">");
  const response = await owner_localizaciones.get();
  return esArray(response.wsResponse.owner_localizaciones);
};
